import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route, Link, useHistory, Redirect, useLocation, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useStripe, useElements, CardNumberElement, CardExpiryElement, CardCvcElement } from '@stripe/react-stripe-js';
import { useCreateCustomerMutation, useGetAllPaymentsQuery } from '../../services/payments';
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from 'react-i18next'
import 'react-loading-skeleton/dist/skeleton.css'
import LockIcon from '@mui/icons-material/Lock';
import Button from '@mui/material/Button';
import Host from '../../Components/Host';
const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      lineHeight: "27px",
      color: "#212529",
      fontSize: "1.1rem",
      "::placeholder": {
        color: "#aab7c4",
      },
    },
    invalid: {
      color: "#fa755a",
      iconColor: "#fa755a",
    },
  },
};

export default function CheckoutForm({ customerNumber, setPaymentCompleted, subscription_price, subscription_code, subscription_trial, language, getPaymentMethodForm, userData, isTrial }) {
  const dispatch = useDispatch();
  const { userId, userToken, userEmail, userName, isMember, isPaymentMethod, isCustomer, languageCode, countryCode, subscription, isPurchase } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState(userEmail);
  const stripe = useStripe();
  const elements = useElements();
  const { t } = useTranslation()
  const history = useHistory();


  const [checked, setChecked] = React.useState(false);

  const [getSelectStatus, setSelectStatus] = React.useState(false);
  const [getSelectPaymentMethodId, setSelectPaymentMethodId] = React.useState('');
  const [getSelectCustomer, setSelectCustomer] = React.useState('');

  // create new customer for stripe account
  const [addNewCustomerMethod, customerResult] = useCreateCustomerMutation()

  const responseInfo = useGetAllPaymentsQuery({ userId: userId, userToken: userToken, countryCode: countryCode }, { count: 1 }, { refetchOnMountOrArgChange: true })
  const paymentData = responseInfo?.data?.result?.data
  const getdefaultPayment = paymentData?.find((l) => l.id === responseInfo?.data?.customer?.invoice_settings?.default_payment_method)



  useEffect(() => {
    try {
      if (customerResult?.data?.success) {
        setPaymentCompleted(true);
      } else {
        setPaymentCompleted(false);
        setLoading(false);
      }
    } catch (e) {
      setPaymentCompleted(false);
      setLoading(false);
    }

  }, [customerResult && customerResult, customerNumber])




  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!stripe || !elements) {
      return;
    }
    setLoading(true);
    const paymentMethodObj = {
      type: 'card',
      card: elements.getElement(CardNumberElement),
      billing_details: { name, email },
    };
    // create a payment method
    const paymentMethodResult = await stripe.createPaymentMethod(paymentMethodObj);
    if (paymentMethodResult?.error) {
      setLoading(false);
      setErrorMsg(typeof paymentMethodResult?.error === 'string' ? paymentMethodResult?.error : paymentMethodResult?.error.message);
      return;
    }


    if (!paymentMethodResult?.error) {
      // add new payment method request
      if (customerNumber && responseInfo?.data?.customer) {
        addNewCustomerMethod({
          payment_method_id: paymentMethodResult?.paymentMethod?.id,
          customer_number: customerNumber,
          add_new_payment_method: true,
          subscription_trial: subscription_trial,
          isTrial: isTrial,
          userId: userId,
          userToken: userToken,
          checked: checked,
          domain: Host?.domain,
          countryCode: countryCode,
        })
      }
      // create new customer request
      else {
        addNewCustomerMethod({
          payment_method_id: paymentMethodResult?.paymentMethod?.id,
          name: paymentMethodResult?.paymentMethod?.billing_details?.name,
          email: paymentMethodResult?.paymentMethod?.billing_details?.email,
          card_country: paymentMethodResult?.paymentMethod?.card?.country,
          new_customer_proceed: true,
          language: languageCode,
          country: countryCode,
          countryCode: countryCode,
          userId: userId,
          userToken: userToken,
          subscription_code: subscription_code,
          subscription_price: subscription_price,
          subscription_trial: subscription_trial,
          isTrial: isTrial,
          checked: checked,
          domain: Host?.domain,
        });
      }
    }
  };



  function buttonDisabled() {
    if (customerResult.isLoading) {
      return true
    } else if (loading) {
      return true
    } else {
      return false
    }
  }


  function checkoutFormDisplay() {
    if (getPaymentMethodForm) {
      return true
    } else {
      if (!customerNumber || !responseInfo?.data?.customer) {
        return true
      } else {
        return false
      }
    }
  }


  function isRtl() {
    if (languageCode === 'ar') {
      return true
    } else {
      return false
    }
  }


  return (
    <React.Fragment>
      {checkoutFormDisplay() &&
        <form onSubmit={handleSubmit}>
          <div className="row padding-card-form">
            <div className="col-md-12">
              <label htmlFor="cc-number">{t('card_number')}</label>
              <div style={{ position: 'relative' }}>
                <CardNumberElement
                  id="cc-number"
                  className="form-control form-control-custom"
                  options={CARD_ELEMENT_OPTIONS}
                />
                <div style={{ position: 'absolute', top: 0, right: isRtl() ? 'auto' : '10px', left: isRtl() ? '10px' : 'auto', display: 'flex', alignItems: 'center', height: '100%' }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ margin: '0 3px' }}>
                      <svg width="24px" height="16px" viewBox="0 0 24 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink">
                        <g id="319" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                          <g id="New-Icons" transform="translate(-80.000000, -280.000000)" fillRule="nonzero">
                            <g id="Card-Brands" transform="translate(40.000000, 200.000000)">
                              <g id="Color" transform="translate(0.000000, 80.000000)">
                                <g id="Visa" transform="translate(40.000000, 0.000000)">
                                  <rect id="Container" strokeOpacity="0.2" stroke="#000000" strokeWidth="0.5" fill="#FFFFFF" x="0.25" y="0.25" width="23.5" height="15.5" rx="2"></rect>
                                  <path d="M2.78773262,5.91443732 C2.26459089,5.62750595 1.6675389,5.39673777 1,5.23659312 L1.0280005,5.1118821 L3.76497922,5.1118821 C4.13596254,5.12488556 4.43699113,5.23650585 4.53494636,5.63071135 L5.12976697,8.46659052 L5.31198338,9.32072617 L6.97796639,5.1118821 L8.77678896,5.1118821 L6.10288111,11.2775284 L4.30396552,11.2775284 L2.78773262,5.91443732 L2.78773262,5.91443732 Z M10.0999752,11.2840738 L8.39882877,11.2840738 L9.46284763,5.1118821 L11.163901,5.1118821 L10.0999752,11.2840738 Z M16.2667821,5.26277458 L16.0354292,6.59558538 L15.881566,6.53004446 C15.5737466,6.40524617 15.1674138,6.28053516 14.6143808,6.29371316 C13.942741,6.29371316 13.6415263,6.56277129 13.6345494,6.82545859 C13.6345494,7.11441463 13.998928,7.3048411 14.5939153,7.58725177 C15.5740257,8.02718756 16.0286384,8.56556562 16.0218476,9.26818871 C16.0080799,10.5486366 14.8460128,11.376058 13.0610509,11.376058 C12.2978746,11.3694253 11.5627918,11.2180965 11.163808,11.0475679 L11.4018587,9.66204513 L11.6258627,9.76066195 C12.1788958,9.99070971 12.5428092,10.0889775 13.221984,10.0889775 C13.7117601,10.0889775 14.2368857,9.89837643 14.2435835,9.48488392 C14.2435835,9.21565125 14.0198586,9.01850486 13.3617074,8.7164581 C12.717789,8.42086943 11.8568435,7.92848346 11.8707973,7.04197926 C11.8780532,5.84042483 13.0610509,5 14.7409877,5 C15.3990458,5 15.9312413,5.13788902 16.2667821,5.26277458 Z M18.5277524,9.0974856 L19.941731,9.0974856 C19.8717762,8.78889347 19.549631,7.31147374 19.549631,7.31147374 L19.4307452,6.77964104 C19.3467437,7.00942698 19.1998574,7.38373457 19.2069273,7.37055657 C19.2069273,7.37055657 18.6678479,8.74290137 18.5277524,9.0974856 Z M20.6276036,5.1118821 L22,11.2839865 L20.4249023,11.2839865 C20.4249023,11.2839865 20.2707601,10.5748181 20.221922,10.3581228 L18.0377903,10.3581228 C17.9746264,10.5221933 17.6807607,11.2839865 17.6807607,11.2839865 L15.8957988,11.2839865 L18.4226343,5.62399144 C18.5977072,5.22341512 18.9059917,5.1118821 19.3117663,5.1118821 L20.6276036,5.1118821 L20.6276036,5.1118821 Z" id="Shape" fill="#1434CB"></path>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </svg>
                    </span>
                    <span style={{ margin: '0 3px' }}>
                      <svg
                        height="16"
                        viewBox="0 0 24 16"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g fill="none" fillRule="evenodd">
                          <rect fill="#252525" height="16" rx="2" width="24" />
                          <circle cx="9" cy="8" fill="#eb001b" r="5" />
                          <circle cx="15" cy="8" fill="#f79e1b" r="5" />
                          <path
                            d="m12 3.99963381c1.2144467.91220633 2 2.36454836 2 4.00036619s-.7855533 3.0881599-2 4.0003662c-1.2144467-.9122063-2-2.36454837-2-4.0003662s.7855533-3.08815986 2-4.00036619z"
                            fill="#ff5f00"
                          />
                        </g>
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row padding-card-form">
            <div className="col-md-6 expiry-date-card">
              <label htmlFor="expiry">{t('expiry_date')}</label>
              <CardExpiryElement
                id="expiry"
                className="form-control form-control-custom"
                options={CARD_ELEMENT_OPTIONS}
              />
            </div>
            <div className="col-md-6 csv-card">
              <label htmlFor="cvc">{t('CSV')}</label>
              <div style={{ position: 'relative' }}>
                <CardCvcElement
                  id="cvc"
                  className="form-control form-control-custom"
                  options={CARD_ELEMENT_OPTIONS}
                />
                <div style={{ position: 'absolute', top: 0, right: isRtl() ? 'auto' : '10px', left: isRtl() ? '10px' : 'auto', display: 'flex', alignItems: 'center', height: '100%' }}>
                  <span style={{ margin: '0 3px' }}>
                    <svg className="p-CardCvcIcons-svg" width="24" height="24" viewBox="0 0 24 24" fill="var(--colorIconCardCvc)" role="img" aria-labelledby="cvcDesc"><path opacity=".2" fillRule="evenodd" clipRule="evenodd" d="M15.337 4A5.493 5.493 0 0013 8.5c0 1.33.472 2.55 1.257 3.5H4a1 1 0 00-1 1v1a1 1 0 001 1h16a1 1 0 001-1v-.6a5.526 5.526 0 002-1.737V18a2 2 0 01-2 2H3a2 2 0 01-2-2V6a2 2 0 012-2h12.337zm6.707.293c.239.202.46.424.662.663a2.01 2.01 0 00-.662-.663z"></path><path opacity=".4" fillRule="evenodd" clipRule="evenodd" d="M13.6 6a5.477 5.477 0 00-.578 3H1V6h12.6z"></path><path fillRule="evenodd" clipRule="evenodd" d="M18.5 14a5.5 5.5 0 110-11 5.5 5.5 0 010 11zm-2.184-7.779h-.621l-1.516.77v.786l1.202-.628v3.63h.943V6.22h-.008zm1.807.629c.448 0 .762.251.762.613 0 .393-.37.668-.904.668h-.235v.668h.283c.565 0 .95.282.95.691 0 .393-.377.66-.911.66-.393 0-.786-.126-1.194-.37v.786c.44.189.88.291 1.312.291 1.029 0 1.736-.526 1.736-1.288 0-.535-.33-.967-.88-1.14.472-.157.778-.573.778-1.045 0-.738-.652-1.241-1.595-1.241a3.143 3.143 0 00-1.234.267v.77c.378-.212.763-.33 1.132-.33zm3.394 1.713c.574 0 .974.338.974.778 0 .463-.4.785-.974.785-.346 0-.707-.11-1.076-.337v.809c.385.173.778.26 1.163.26.204 0 .392-.032.573-.08a4.313 4.313 0 00.644-2.262l-.015-.33a1.807 1.807 0 00-.967-.252 3 3 0 00-.448.032V6.944h1.132a4.423 4.423 0 00-.362-.723h-1.587v2.475a3.9 3.9 0 01.943-.133z"></path></svg>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="row padding-card-form">
            <div className="col-md-12">
              <label htmlFor="cc-name">{t('name_on_card')}</label>
              <input
                id="cc-name"
                type="text"
                className="form-control form-control-custom"
                value={name}
                onChange={e => setName(e.target.value)}
                placeholder={t('name')}
              />
            </div>
          </div>

          {/* <div className="row padding-card-form">
            <div className="col-md-12">
              <FormGroup>
                <FormControlLabel control={<Checkbox defaultChecked={checked} onChange={() => setChecked(!checked)} />}
                  label={<span className="accept-text">{t('i_accept')} <Link to={`/${language}/terms-and-conditions`}>{t('terms_and_condition')}</Link></span>} />
              </FormGroup>
            </div>
          </div> */}

          <div className="padding-card-form" style={{ padding: '20px 0px 0px 0px' }}>
            <Button
              style={{ background: Host?.bgColor, color: Host?.buttonColor, width: '100%', height: '45px' }}
              type="submit"
              disabled={buttonDisabled()}
            >
              {(loading) || (customerResult?.isLoading) ?
                <div className="spinner-border spinner-border-sm text-dark" style={{fontSize: '7px'}} role="status"></div>
                :
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <span style={{ textAlign: 'center', width: '100%' }}>{t('add')}</span>
                </div>
              }
            </Button>
          </div>

          {!customerNumber &&
            <div style={{ display: 'flex', alignItems: 'center', padding: '20px 0px 0px 0px', color: '#25273478' }}>
              <LockIcon style={{ fontSize: '16px' }} /> &nbsp;<span style={{ fontSize: '14px' }}>Secure transaction</span></div>
          }

          {errorMsg &&
            <div className="text-danger mt-2" style={{ padding: '0px 20px 20px 20px' }}>
              {errorMsg}
            </div>
          }
          {customerResult?.error?.data?.error &&
            <div className="text-danger mt-2" style={{ padding: '0px 20px 20px 20px' }}>
              {customerResult?.error?.data?.error}
            </div>
          }
          <br />
        </form>
      }



    </React.Fragment>
  );
}